export default {
  accounts: {
    section: 'Bancos y Cajas',
    loading: 'Cargando bancos...',
    banks: {
      headers: {
        name: 'Nombre',
        account: 'Cuenta',
        type: 'Tipo',
        id: 'Clabe/Identificación'
      }
    },
    accounts: {
      headers: {
        name: 'Nombre'
      }
    },
    accountTypeDialog: {
      title: 'Selecciona tu tipo de cuenta',
      personal: 'Cuenta personal',
      business: 'Cuenta empresarial',
      button: 'Siguiente'
    },
    bankDialog: {
      title: 'Selecciona tu banco',
      button: 'Siguiente'
    },
    bankData: {
      title: 'Introduce los datos con los que accedes a la banca en línea web',
      clientNumber: 'Número de cliente',
      clientNumberErrorsReq: 'Se requiere un número de cliente',
      bancanet: 'Contraseña de bancanet',
      bancanetErrorsReq: 'Se requiere una contraseña de bancanet',
      securityCode: 'Código de seguridad',
      securityCodeErrorsReq: 'Se requiere un código de seguridad',
      text1: 'Al hacer click en “Enviar” información  aceptas expresamente nuestros ',
      text2: 'Términos de servicio',
      text3: ' al igual que nuestro ',
      text4: 'Aviso de privacidad.',
      finerio: 'Gestionado por',
      button: 'Enviar'
    },
    success: {
      title: 'Tus cuentas han sido vinculadas exitosamente',
      text: 'Presiona siguiente para regresar a bancos y cuentas.',
      button: 'Regresar a bancos y cuentas'
    }

  },
  incomeCategories: {
    section: 'Categorías de ingreso',
    tableIncomeCategories: {
      loadingText: 'Cargando...',
      headers: {
        type: 'Tipo de ingreso',
        concept: 'Concepto de ingreso',
        category: 'Categoría de ingreso',
        includedInCharges: 'Incluir en cobranza'
      }
    },
    editCategoryDialog: {
      createTitle: 'Crear categoría de ingreso',
      editTitle: 'Editar categoría de ingreso',
      type: 'Tipo de ingreso',
      concept: 'Concepto de ingreso',
      name: 'Nombre de categoría',
      includedInCharges: 'Incluir en cobranza',
      buttonCancel: 'Cancelar',
      buttonEdit: 'Guardar',
      buttonCreate: 'Crear categoría de ingreso'
    },
    conceptDialog: {
      title: 'Conceptos de ingresos',
      needInvoice: 'Lleva factura',
      editableTip: 'Propina editable',
      buttonCancel: 'Cancelar',
      buttonCreate: 'Crear concepto',
      buttonEdit: 'Editar concepto',
      table: {
        loadingText: 'Cargando conceptos de ingresos...',
        headers: {
          type: 'Tipo de ingreso',
          name: 'Concepto de ingreso'
        }
      }
    },
    editConceptDialog: {
      createTitle: 'Crear concepto de ingreso',
      editTitle: 'Editar concepto de ingreso',
      type: 'Tipo de ingreso',
      name: 'Concepto de ingreso',
      buttonCancel: 'Cancelar',
      buttonCreate: 'Crear',
      buttonEdit: 'Guardar'
    },
    typeDialog: {
      title: 'Tipos de ingresos',
      buttonCreate: 'Crear tipo de ingreso',
      table: {
        loadingText: 'Cargando tipos de ingresos...',
        headers: {
          name: 'Nombre',
          includedInCharges: 'Incluir en cobranza'
        }
      }
    },
    editTypeDialog: {
      createTitle: 'Crear tipo de ingreso',
      editTitle: 'Editar tipo de ingreso',
      name: 'Nombre',
      includedInCharges: 'Incluir en cobranza',
      buttonCancel: 'Cancelar',
      buttonCreate: 'Crear',
      buttonEdit: 'Editar'
    },
    yes: 'Sí',
    no: 'No'
  },
  outgoingCategories: {
    section: 'Categorías de egreso',
    loading: 'Cargando...',
    typeDialog: {
      title: 'Tipos de egresos',
      buttonCreate: 'Crear tipo de egreso',
      table: {
        loadingText: 'Cargando tipos de egresos...',
        headers: {
          name: 'Nombre'
        }
      }
    },
    editTypeDialog: {
      createTitle: 'Crear tipo de egreso',
      editTitle: 'Editar tipo de egreso',
      name: 'Nombre',
      buttonCancel: 'Cancelar',
      buttonCreate: 'Crear',
      buttonEdit: 'Guardar'
    },
    conceptDialog: {
      title: 'Conceptos de egresos',
      buttonCreate: 'Crear concepto de egreso',
      table: {
        loadingText: 'Cargando conceptos de egresos...',
        headers: {
          type: 'Tipo de egreso',
          name: 'Concepto de egreso'
        }
      }
    },
    editConceptDialog: {
      createTitle: 'Crear concepto de egreso',
      editTitle: 'Editar concepto de egreso',
      type: 'Tipo de egreso',
      name: 'Concepto de egreso',
      buttonCancel: 'Cancelar',
      buttonCreate: 'Crear',
      buttonEdit: 'Guardar'
    },
    editCategoryDialog: {
      createTitle: 'Crear categoría de egreso',
      editTitle: 'Editar categoría de egreso',
      type: 'Tipo de egreso',
      concept: 'Concepto de egreso',
      name: 'Categoría de egreso',
      buttonCancel: 'Cancelar',
      buttonCreate: 'Crear',
      buttonEdit: 'Guardar'
    }
  },
  registerMovements: {
    section: 'Registro de movimientos',
    inputSearchLabel: 'Buscar...',
    tabs: {
      payOrders: 'Órdenes de pago',
      invoices: 'Buzón de facturas',
      other: 'Otros movimientos'
    },
    payOrders: {
      buttonCreate: 'Crear orden de pago',
      loading: 'Cargando cuentas...',
      headers: {
        id: 'Id de orden de pago',
        supplier: 'Proveedor',
        amount: 'Monto',
        date: 'Fecha',
        paymentMode: 'Forma de pago',
        paymentType: 'Tipo de pago',
        status: 'Status',
        support: 'Soporte'
      },
      drawer: {
        title: 'Crear órdenes de pago',
        // account: 'Cuenta',
        // accountErrorsReq: 'Se requiere una cuenta',
        // paymentMode: 'Forma de pago',
        // paymentModeErrorsReq: 'Se requiere una forma de pago',
        // bank: 'Banco/Caja',
        // bankErrorsReq: 'Se requiere un banco/caja',
        // paymentType: 'Tipo de pago',
        // paymentTypeErrorsReq: 'Se requiere un tipo de pago',
        supplier: 'Proveedor',
        supplierErrorsReq: 'Se requiere un proveedor',
        headers: {
          quantity: 'Cantidad',
          unit: 'Unidad',
          concept: 'Concepto',
          category: 'Categoría',
          cost: 'Costo unitario',
          amount: 'Importe',
          discount: 'Descuento'
        },
        buttonAdd: '+ Agregar producto o servicio',
        buttonCreate: 'Crear',
        dialog: {
          title: 'Agregar producto o servicio',
          quantity: 'Cantidad',
          quantityErrorsMin: 'La cantidad debe ser un número positivo',
          quantityErrorsDec: 'La cantidad debe ser un número',
          quantityErrorsReq: 'Se requiere una cantidad',
          unit: 'Unidad',
          unitErrorsReq: 'Se requiere una unidad',
          concept: 'Concepto',
          conceptErrorsReq: 'Se requiere un concepto',
          category: 'Categoría',
          categoryErrorsReq: 'Se requiere una categoría',
          cost: 'Costo unitario',
          costErrorsMin: 'El costo debe ser un número positivo',
          costErrorsDec: 'El costo debe ser un número',
          costErrorsReq: 'Se requiere un costo',
          amount: 'Importe',
          discount: 'Descuento',
          discountErrorsBet: 'El descuento debe ser entre 0% y 100%',
          discountErrorsDec: 'El descuento debe ser un número',
          discountErrorsReq: 'Se requiere un descuento',
          buttonCancel: 'Cancelar',
          buttonAdd: 'Agregar'
        },
        subtotal: 'Subtotal:',
        discount: 'Descuento:',
        taxes: 'Impuestos:',
        taxesErrorsMin: 'El impuesto debe ser un número positivoo',
        taxesErrorsDec: 'El impuesto debe ser un número',
        taxesErrorsReq: 'Se requiere indicar el impuesto',
        total: 'Total:'
      },
      drawerDetails: {
        title: 'Detalles de orden de pago con ID',
        supplier: 'Proveedor',
        author: 'Creador',
        status: 'Status',
        creationDate: 'Fecha de creación',
        subtotal: 'Subtotal',
        taxes: 'Impuestos',
        total: 'Total',
        paymentConcept: 'Concepto de pago',
        loading: 'Cargando orden de pago...',
        headers: {
          quantity: 'Cantidad',
          // unit: 'Unidad', // Todo: solve matching between satws units and DB units
          concept: 'Concepto',
          category: 'Categoría',
          cost: 'Costo unitario',
          amount: 'Importe',
          discount: 'Descuento'
        },
        invoiceLink: 'Ver factura',
        documentLink: 'Ver pdf',
        statusTypes: {
          created: 'Creado',
          pendingPayment: 'Por pagar',
          paid: 'Pagado'
        },
        buttonClose: 'Cerrar',
        buttonAttachDocument: 'Adjuntar documento'
      }
    },
    invoices: {
      loading: 'Cargando facturas...',
      buttonDownload: 'Descargar facturas',
      buttonGenerate: 'Generar órden de pago',
      headers: {
        id: 'Folio de factura',
        supplier: 'Proveedor',
        receiver: 'Receptor',
        amount: 'Monto',
        date: 'Fecha',
        status: 'Status',
        actions: 'Acciones'
      },
      downloadDialog: {
        title: 'Descarga de facturas',
        text: 'Selecciona el intervalo en que deseas descargar las facturas',
        issuerTaxIdLabel: 'RFC del emisor',
        label: 'Intervalo de fechas',
        buttonCancel: 'Cancelar',
        buttonConfirm: 'Confirmar'
      },
      unlinkInvoiceDialog: {
        title: 'Desvincular factura',
        text: '¿Deseas desvincular a la factura de la orden de pago?',
        buttonCancel: 'Cancelar',
        buttonConfirm: 'Confirmar'
      },
      unlik: 'Desvincular factura',
      searchMatchs: 'Buscar coincidencias',
      drawerRelate: {
        title: 'Órdenes de pago con coincidencia',
        loading: 'Cargando órdenes de pago con coincidencia...',
        headers: {
          id: 'Orden de pago',
          amount: 'Monto',
          paymentMode: 'Forma de pago',
          date: 'Fecha',
          status: 'Status'
        },
        buttonRelate: 'Relacionar a orden de pago',
        successDialog: {
          text: 'La factura se relacionó con la orden de pago con éxito',
          buttonAccept: 'Aceptar'
        },
        paymentTypes: {
          balance: 'PUE',
          credit: 'PPD'
        },
        statusTypes: {
          created: 'Creado',
          pendingPayment: 'Por pagar',
          paid: 'Pagado'
        }
      },
      drawerGenerate: {
        title: 'Generar órdenes de pago',
        id: 'Folio:',
        supplier: 'Proveedor:',
        status: 'Estatus:',
        loading: 'Generando orden de pago...',
        headers: {
          quantity: 'Cantidad',
          concept: 'Concepto',
          category: 'Categoría',
          cost: 'Costo unitario',
          amount: 'Importe',
          discount: 'Descuento'
        },
        validations: {
          categoryReq: 'Se requiere una categoría'
        },
        // buttonEdit: 'Editar',
        buttonSave: 'Guardar',
        successDialog: {
          text: 'La orden de pago se generó con éxito',
          buttonAccept: 'Aceptar'
        },
        updateItemsCategoryDialog: {
          title: 'Seleccionar otra categoría',
          label: 'Nueva categoría',
          buttonAccept: 'Aceptar'
        },
        warningDialog: {
          text: '¿Estás seguro que editar esta categoría para todos tus conceptos y RFC?',
          buttonCancel: 'Cancelar',
          buttonConfirm: 'Confirmar'
        },
        editCategoryDialog: {
          title: 'Editar concepto de pago',
          text: 'Ingresar una nueva descripción para la categoría',
          alert: 'Estás a punto de editar esta categoría',
          concept: 'Concepto',
          label: 'Editar categoría'
        },
        editCategorySuccessDialog: {
          title: 'Editar concepto de pago',
          success: 'La categoría ha sido cambiada correctamente',
          concept: 'Concepto',
          buttonCancel: 'Cancelar',
          buttonConfirm: 'Confirmar'
        },
        editionTypeDialog: {
          title: 'Editar categoría',
          text: '¿Quieres asignar esta categoría de pago a la orden de pago seleccionada o a toda la serie?',
          payOrder: 'A esta orden de pago',
          all: 'A toda la serie',
          buttonCancel: 'Cancelar',
          buttonConfirm: 'Confirmar'
        }
      },
      paymentTypes: {
        balance: 'PUE',
        credit: 'PPD'
      },
      statusTypes: {
        created: 'Creado',
        pendingPayment: 'Por pagar',
        paid: 'Pagado'
      }
    },
    movements: {
      buttonCreate: 'Crear movimiento',
      loading: 'Cargando movimientos bancarios...',
      headers: {
        id: 'Folio',
        date: 'Fecha contable',
        beneficiary: 'A la orden de',
        description: 'Descripción',
        charge: 'Cargo',
        deposit: 'Abono',
        balance: 'Balance',
        type: 'Tipo de movimiento',
        category: 'Categoría/Tipo'
      },
      bank: 'Banco y cuenta',
      box: 'Seleccione banco o caja',
      bankErrorsReq: 'Se requiere un banco y cuenta',
      drawerAdd: {
        title: 'Crear movimiento',
        type: 'Tipo de movimiento:',
        deposit: 'Deposito',
        withdrawal: 'Retiro',
        transfer: 'Traspaso',
        outgoingCategory: 'Categoría de egreso',
        incomeType: 'Tipos de ingreso',
        id: 'Folio',
        idErrorsReq: 'Se requiere un folio',
        date: 'Fecha',
        dateErrorsReq: 'Se requiere una fecha',
        bank: 'Banco/Caja',
        bankErrorsReq: 'Se requiere un banco/caja',
        originBank: 'Banco y cuenta de origen',
        originBankErrorsReq: 'Se requiere una cuenta de origen',
        destinationBank: 'Banco y cuenta de destino',
        destinationBankErrorsReq: 'Se requiere una cuenta de destino',
        concept: 'Descripción',
        conceptErrorsReq: 'Se requiere una descripción',
        beneficiary: 'A la orden de',
        beneficiaryErrorsReq: 'Se requiere un autor',
        amount: 'Monto',
        amountErrorsMin: 'Se requiere un monto positivo',
        amountErrorsDec: 'Se requiere un monto numérico',
        amountErrorsReq: 'Se requiere un monto',
        buttonCreate: 'Crear',
        successDialog: {
          text: 'El movimiento se creó con éxito',
          buttonAccept: 'Aceptar'
        }
      },
      paymentTypes: {
        balance: 'PUE',
        credit: 'PPD'
      },
      statusTypes: {
        created: 'Creado',
        pendingPayment: 'Por pagar',
        paid: 'Pagado'
      },
      movementsDateDialog: {
        title: 'Fecha',
        subtitle: 'Selecciona el intervalo de fechas que deseas consultar.',
        date: 'Intervalo de fechas',
        buttonBack: 'Atrás',
        buttonSend: 'Enviar'
      }
    }
  },
  bankReconciliation: {
    section: 'Conciliación bancaria',
    search: 'Buscar...',
    transactions: {
      title: 'Transacciones',
      bank: 'Seleccionar un banco',
      account: 'Seleccionar una cuenta',
      buttonUpload: 'Cargar transacciones manualmente',
      buttonRelatedSelectedTransactions: 'Relacionar movimientos',
      dialogUpload: {
        title: '',
        dropzoneText: 'Arrastra tu archivo XLSX para cargar las transacciones',
        buttonClose: 'Cerrar'
      },
      dialogPreview: {
        title: 'Vista previa de transacciones',
        buttonCancel: 'Cancelar',
        buttonSend: 'Relacionar movimientos'
      },
      dialogUploadError: {
        title: '',
        transactionError: 'Error al registrar las transacciones. Verifica tus datos.',
        buttonClose: 'Cerrar'
      },
      dialogUploadSucess: {
        title: '',
        text: 'Las transacciones se han registrado con éxito.',
        buttonClose: 'Cerrar'
      },
      loading: 'Cargando movimientos bancarios...',
      headers: {
        date: 'Fecha',
        description: 'Descripción',
        charge: 'Cargo',
        deposit: 'Abono',
        balance: 'Balance',
        actions: 'Acciones'
      },
      relate: 'Relacionar movimientos',
      relatePanel: {
        title: 'Relacionar movimientos',
        tableMovements: {
          title: 'Otros movimientos',
          loading: 'Cargando movimientos similares...',
          headers: {
            id: 'Folio',
            date: 'Fecha',
            author: 'A la orden',
            concept: 'Concepto',
            amount: 'Monto'
          }
        },
        tableOrders: {
          title: 'Listado de órdenes',
          loading: 'Cargando órdenes...',
          headers: {
            id: 'ID',
            date: 'Fecha',
            paymentMethod: 'Tipo de pago',
            status: 'Estatus',
            amount: 'Monto',
            invoice: 'Factura',
            supplier: 'Proveedor'
          }
        },
        noInfo: 'No hay información disponible',
        button: 'Relacionar movimientos',
        warningDialog: {
          text: 'El monto de estas transacciones no coincide con el monto de las órdenes de pago y/o movimientos. ¿Aún así desea relacionarlos?',
          transactionsAmount: 'Monto de las transacciones: ',
          ordersAndMovementsAmount: 'Monto de los movimientos y/o órdenes: ',
          buttonCancel: 'Cancelar',
          buttonConfirm: 'Confirmar'
        }
      },
      details: 'Ver documentos relacionados',
      relationsPanel: {
        title: 'Documentos relacionados',
        noInfo: 'No hay información disponible',
        tableMovements: {
          title: 'Otros movimientos',
          loading: 'Cargando movimientos...',
          headers: {
            id: 'Folio',
            date: 'Fecha',
            author: 'A la orden',
            concept: 'Concepto',
            amount: 'Monto'
          }
        },
        tableOrders: {
          title: 'Listado de órdenes',
          loading: 'Cargando órdenes...',
          headers: {
            id: 'ID',
            date: 'Fecha',
            paymentMethod: 'Tipo de pago',
            status: 'Status',
            amount: 'Monto',
            supplier: 'Proveedor'
          }
        },
        buttonClose: 'Cerrar',
        statusTypes: {
          created: 'Creado',
          pendingPayment: 'Por pagar',
          paid: 'Pagado'
        },
        paymentTypes: {
          balance: 'PUE',
          credit: 'PPD'
        }
      },
      buttonCompleted: 'Completado',
      warningDialog: {
        text: '¿Está seguro que quiere cerrar la conciliación? Una vez realizado esto no podrá realizar más cambios.',
        buttonCancel: 'Cancelar',
        buttonConfirm: 'Confirmar'
      }
    },
    relations: {
      title: 'Ver relaciones',
      tableRelations: {
        loadingText: 'Cargando relaciones...',
        headers: {
          id: 'ID',
          date: 'Fecha de modificación',
          modifiedBy: '¿Quién modificó?',
          transactions: 'Transacciones relacionadas',
          orders: 'Órdenes de pago',
          movements: 'Otros movimientos'
        },
        differenceText: 'Faltan {difference} por relacionar.'
      },
      relatedTransactionsDialog: {
        title: 'Transacciones relacionadas',
        add: 'Agregar',
        table: {
          loadingText: 'Cargando transacciones...',
          headers: {
            date: 'Fecha',
            description: 'Descripción',
            amount: 'Monto',
            editor: 'Editor',
            actions: 'Acciones'
          },
          noInfo: 'No hay información disponible'
        },
        sum: 'Suma de las transacciones: {sum}'
      },
      relatedPayOrdersDialog: {
        title: 'Órdenes de pago relacionadas',
        add: 'Agregar',
        table: {
          loadingText: 'Cargando órdenes de pago...',
          headers: {
            id: 'ID',
            date: 'Fecha',
            paymentMethod: 'Tipo de pago',
            status: 'Estatus',
            amount: 'Monto',
            invoice: 'Factura',
            supplier: 'Proveedor',
            actions: 'Acciones'
          },
          noInfo: 'No hay información disponible'
        },
        sum: 'Suma de las órdenes de pago: {sum}'
      },
      relatedMovementsDialog: {
        title: 'Movimientos relacionados',
        add: 'Agregar',
        table: {
          loadingText: 'Cargando movimientos...',
          headers: {
            id: 'Folio',
            date: 'Fecha',
            author: 'A la orden',
            concept: 'Concepto',
            amount: 'Monto',
            actions: 'Acciones'
          },
          noInfo: 'No hay información disponible'
        },
        sum: 'Suma de los movimientos: {sum}'
      },
      addRelatedTransactionsDialog: {
        title: 'Agregar transacciones',
        table: {
          loadingText: 'Cargando transacciones...',
          headers: {
            date: 'Fecha',
            description: 'Descripción',
            amount: 'Monto',
            editor: 'Editor',
            actions: 'Acciones'
          },
          noInfo: 'No hay información disponible'
        }
      },
      addRelatedPayOrdersDialog: {
        title: 'Agregar órdenes de pago',
        table: {
          loadingText: 'Cargando órdenes de pago...',
          headers: {
            id: 'ID',
            date: 'Fecha',
            paymentMethod: 'Tipo de pago',
            status: 'Estatus',
            amount: 'Monto',
            invoice: 'Factura',
            supplier: 'Proveedor',
            actions: 'Acciones'
          },
          noInfo: 'No hay información disponible'
        }
      },
      addRelatedMovementsDialog: {
        title: 'Agregar movimientos',
        table: {
          loadingText: 'Cargando movimientos...',
          headers: {
            id: 'Folio',
            date: 'Fecha',
            author: 'A la orden',
            concept: 'Concepto',
            amount: 'Monto',
            actions: 'Acciones'
          },
          noInfo: 'No hay información disponible'
        }
      }
    }
  },
  footerText: 'Filas por mostrar:'
}
